module.exports = __webpack_public_path__ + "2024523:cc8b0e4ed9b4c71b9cb2/img/hero@2x.10700a4.png";